import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { loginActions } from './app/store/user-login.reducer';
import { adminSettingActions } from './app/store/admin-setting.reducer';
import Routes from './app/routes';
import { NoSubscription } from './app/components/external/dashboard/no-subscription/no-subscription.component';
import Translation from './app/components/common/translation/translation.component';
import { TRANSLATIONS } from './app/utils/constant.utils';
// Ensure this path points to your new chatbot.js file
import ChatbotWidget from './app/components/common/chatbot/chatbot'; 

class App extends Component {
    constructor(props) {
        super(props);

        this.state = {
            hasLoaded: false,
            userId: null,
        };
    }

    async componentDidMount() {
        await this.props.getUserAuth();
        await this.props.getAdminSetting();
       
        const userStr = sessionStorage.getItem('User');
        let userId = null;

        if (userStr && userStr !== 'null' && userStr !== 'undefined') {
            try {
                const user = JSON.parse(userStr);
                userId = user?.Employee?.UserId ?? null;
            } catch (err) {
                console.error('Error parsing User from sessionStorage', err, userStr);
            }
        } 

        this.setState({
            hasLoaded: true,
            userId,            
        });
    }

    render() {
        if (this.state.hasLoaded) {
            return (
                <div>
                  
                    {(this.props.isLoggedIn || this.state.userId) && <ChatbotWidget />}
                    
                    {Routes}                    
                </div>
            );
        }
        else {
            return (
                <div className="app-container-loading">
                    <NoSubscription title={<Translation locale={TRANSLATIONS.defaultLocaleLanguage} translationKey="loading" />} noOverviewContainer={true} />
                </div>
            );
        }
    }
}

export default connect(
  state => ({
    isLoggedIn:
      state.authentication &&
      typeof state.authentication.isLoggedIn === 'boolean'
        ? state.authentication.isLoggedIn
        : false,
  }),

  dispatch =>
    bindActionCreators(
      Object.assign({}, loginActions, adminSettingActions),
      dispatch
    )
)(App);